export class CookieConsentService {
  public static renew() {
    if (typeof Cookiebot !== typeof undefined && 'renew' in Cookiebot) {
      Cookiebot.renew();
    }
  }
}
